import { Injectable } from '@angular/core';

export enum StorageKey {
  accessToken = 'access_token',
  expires = 'expires',
  refreshToken = 'refresh_token',
  tokenType = 'token_type',
};

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  localStorage: Storage = window.localStorage;

  clear(): void {
    if (this.isLocalStorageSupported) {
      localStorage.clear();
    }
  }

  set(key: string, value: unknown): void {
    if (this.isLocalStorageSupported) {
      const stringValue = JSON.stringify(value);
      localStorage.setItem(key, stringValue);
    }
  }

  get<T>(key: string): T | null {
    if (this.isLocalStorageSupported) {
      try {
        return JSON.parse(localStorage.getItem(key)!);
      }
      catch (e) {
        console.error(`Error getting item ${key} from localStorage`, e);
        return null;
      }
    }
    return null;
  }

  remove(key: string): void {
    if (this.isLocalStorageSupported) {
      localStorage.removeItem(key);
    }
  }

  private get isLocalStorageSupported(): boolean {
    return !!this.localStorage;
  }
}
